import { isNumber } from 'lodash';

import { write } from '@revelio/core';

import type {
  CompanyMappingState,
  CompanyMappingStateValue,
  RevelioMappedCompany,
} from './company-mapping.model';
import {
  getCompanyMapping as getCompanyMappingFromStore,
  selectCompanyMapping as selectCompanyMappingFromStore,
  useCompanyMappingStore,
} from './company-mapping.store';

export const selectCompanyMapping = selectCompanyMappingFromStore;
export const getCompanyMapping = () => getCompanyMappingFromStore();

const getStoreActions = () => useCompanyMappingStore.getState().actions;

export const setCompanyMapping = (value: CompanyMappingState | null) => {
  getStoreActions().setCompanyMapping(value);
};
export const resetCompanyMapping = () => {
  getStoreActions().setCompanyMapping(null);
};
export const updateCompanyMapping = (
  updater: (state: CompanyMappingState | null) => CompanyMappingState | null
) => {
  const current = getCompanyMapping();
  getStoreActions().setCompanyMapping(updater(current));
};

export function excludeVerifiedMapping(rcid: number) {
  const updated = write<CompanyMappingState | null>((state) => {
    const mappingToExclude = state?.verifiedMappings.find(
      (mapping) => mapping.response.rcid === rcid
    ) as CompanyMappingStateValue;
    if (!mappingToExclude) {
      return;
    }
    mappingToExclude.isExcluded =
      mappingToExclude.isExcluded === undefined
        ? true
        : !mappingToExclude.isExcluded;
  })(getCompanyMapping());
  setCompanyMapping(updated);
}

export function remapCompany({
  rcid,
  newMapping,
  missingCompaniesIndexToMap,
}: {
  rcid?: number;
  newMapping: RevelioMappedCompany;
  missingCompaniesIndexToMap?: number;
}) {
  const updated = write<CompanyMappingState | null>((state) => {
    if (!state) {
      return;
    }
    if (isNumber(missingCompaniesIndexToMap)) {
      const requestCompanyId =
        // @ts-expect-error noUncheckedIndexedAccess
        state.missingMappings[missingCompaniesIndexToMap].request.company_id;
      state.verifiedMappings = [
        // @ts-expect-error noUncheckedIndexedAccess
        {
          ...state.missingMappings[missingCompaniesIndexToMap],
          // search returns rcid as string as company id when we want the user's provided company_id if there is one
          response: { ...newMapping, company_id: requestCompanyId },
        },
        ...state.verifiedMappings,
      ];
      state.missingMappings.splice(missingCompaniesIndexToMap, 1);
      return;
    }

    const verifiedCompanyToRemap = state.verifiedMappings.find(
      (mapping) => mapping.response.rcid === rcid
    ) as CompanyMappingStateValue;
    if (verifiedCompanyToRemap) {
      const requestCompanyId = verifiedCompanyToRemap.request.company_id;
      // search returns rcid as string as company id when we want the user's provided company_id if there is one
      verifiedCompanyToRemap.response = {
        ...newMapping,
        company_id: requestCompanyId,
      };
    }
  })(getCompanyMapping());
  setCompanyMapping(updated);
}
